<template>
  <EventCard
    :title="event?.title"
    :eventTypes="getEventTypes(event)"
    :thumbnail="event?.thumbnail"
    :tags="event?.archiveTags"
    :link="event?.link"
    :category="event?.category?.name"
    :description="event?.archiveDescription"
    buttonLabel="詳細・視聴"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import EventCard from '@/components/block/EventCard.vue'
import { getEventTypes } from '@/utils/commonMethods'
export default defineComponent({
  name: 'EventCardArchive',
  components: {
    EventCard
  },
  props: {
    event: Object,
    rectangle: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return {
      getEventTypes
    }
  }
})
</script>
